import Box from "@mui/material/Box";

import PrimaryBrand from "src/assets/Images/primary-brand.png";
import YellowBrand from "src/assets/Images/yellow-brand.png";

const BlackLogo = ({ sx = {} }) => {
  return (
    <Box
      component="img"
      src={PrimaryBrand}
      sx={{
        mb: 2,
        width: { xs: 50, md: 110 },
        height: { xs: 40, md: 100 },
        ...sx,
      }}
    />
  );
};

const YellowLogo = ({ sx = {} }) => {
  return (
    <Box
      component="img"
      src={YellowBrand}
      width={{ xs: 50, md: 110 }}
      height={{ xs: 40, md: 100 }}
      sx={sx}
    />
  );
};

export { BlackLogo, YellowLogo };
